export default "__VITE_ASSET__CGn2nXeo__"